module.exports = __WEBPACK_EXTERNAL_MODULE_223__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 223
// module chunks = 0